@if(isDealerOpeningHoursValid()) {
  <div>
    <p>{{'schedule.attendance-hour' | translate}}</p>
    <p>{{'schedule.office-hours-during-week' | translate : {minHour: minHour(), maxHour: maxHour()} }}</p>

    @if (isDealerOpeningWeekend()) {
      <p>{{'schedule.office-hours-during-saturday-sunday' | translate : {minHour: minHourWeekend(), maxHour: maxHourWeekend()} }}</p>
    }
  </div>
}
